<style lang="stylus">
    .emptyCloud
        display flex
        justify-content center
        flex-wrap wrap
        font-size 14px !important
        font-weight 500
        position absolute
        top 100px
        left 50%
        transform translate(-50%,0)
        svg,img
            cursor pointer
        span
            color #222
        .login-animation
          display inline-block
          font-size 16px
          animation btnbor 1.3s ease-out infinite
    @keyframes btnbor {
        0% {
            transform perspective(1px) scale(0.8)
        }
        50% {
            transform scale(1)
        }
        100% {
            transform perspective(1px) scale(0.8)
        }
    }
</style>

<template>
    <div class="emptyCloud" style="width: 250px" v-cloak v-if="pcNoLogin">
        <!-- <span style='margin-right: 4px'>{{$t("reloadPre")}}</span> -->
        <!-- <iconSymbol name="toLoginIcon" @click.native="toPCLogin" /> -->
        <img src="@/home/assets/img/null-icon/recent-null.svg" alt="" @click="toPCLogin" />
        <p style="text-align: center; position: relative">
            <span>{{ $t("loginPre") }}</span>
            <a class="login-animation" @click="toPCLogin()">【{{ $t("login") }}】</a>
            <span class="tips-end">{{ $t("see") }}</span>
        </p>
    </div>
</template>

<script lang="ts">
    import { Component, Prop, Vue } from "vue-property-decorator";

    @Component({
        components: {},
    })
    export default class PClogin extends Vue {
        get pcNoLogin() {
            return this.isPC && !this.params.islogin;
        }
        toPCLogin() {
            (<any>window).$qt.jsCallUpdateLoginTrigger && (<any>window).$qt.jsCallUpdateLoginTrigger("toUseCloudFile");
            (<any>window).$qt.jsCallUserLogin();
        }
    }
</script>
<i18n>
{
  "zh": {
    "loginPre": "您还没有登录，请",
    "login": "登录",
    "see": "后查看。"
  },
  "en": {
    "loginPre": "You are not logged in, please",
    "login": "log in",
    "see": " view after."
  },
  "fr": {
    "loginPre": "Vous vous n'êtes pas connecté, veuillez",
    "login": "connexion",
    "see": "vue postérieure"
  },
  "de": {
    "loginPre": "Sie haben sich nicht angemeldet. Bitte zuerst",
    "login": "anmelden",
    "see": ""
  },
  "jp": {
    "loginPre": "ログインしていません。まず",
    "login": "ログイン",
    "see": "してください。"
  },
  "es": {
    "loginPre": "No ha iniciado sesión, por favor",
    "login": "inicia sesión",
    "see": "vista posterior"
  },
  "pt": {
    "loginPre": "Você não está logado, por favor",
    "login": "conecte-se",
    "see": "vista posterior"
  },
  "it": {
    "loginPre": "Non sei loggato, per favore",
    "login": "accesso",
    "see": "vista successiva"
  },
  "tw": {
    "loginPre": "您還沒有登登錄，請",
    "login": "登錄",
    "see": "後查看。"
  },
  "kr": {
    "loginPre": "로그인이 되어있지 않습니다",
    "login": "로그인",
    "see": "나중에 보기"
  },
  "id": {
    "loginPre": "Anda belum masuk, silakan",
    "login": "log in",
    "see": "dan lihat setelahnya."
  }
}
</i18n>
